import React from 'react';
import PropTypes from 'prop-types';
import Lookup from './Lookup';
import defaultStyles from './Symbol.module.scss';

const Symbol = ({ children, symbol, styles }) => (
    symbol ? (
        <div>
            { children }
            <img
                src={ Lookup[symbol] }
                alt=""
                className={ styles.svg }
            />
        </div>
    ) : (children || null)
);

Symbol.propTypes = {
    symbol: PropTypes.string,
    children: PropTypes.string.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

Symbol.defaultProps = {
    symbol: '',
    styles: defaultStyles
};

export { defaultStyles };
export default Symbol;
